// Module
var code = "<select class=\"browser-default\" ng-model=\"selectedCategory\" ng-change=\"setCategory(selectedCategory)\" ng-show=\"showSelect()\"> <option value=\"\">All field types</option> <option ng-repeat=\"(name, category) in categories\">{{ name }}</option> </select> ";
// Exports
export default code;